import React from 'react';
import PropTypes from 'proptypes';
import classnames from 'classnames';
import moment from 'moment';
import 'moment/locale/de';

import { LinkButtonComponent as LinkButton } from 'components/button';
import {
  getTitle,
  getRequestTitle,
  getMessage,
  getRequestMessage
} from './utils';


import styles from './lecture-component.styles.scss';


export class LectureComponent extends React.Component {
  static propTypes = {
    lecture: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      tags: PropTypes.arrayOf(PropTypes.string).isRequired,
      duration: PropTypes.number,
      date: PropTypes.number,
      seats: PropTypes.number,
      fee: PropTypes.number,
    }).isRequired,
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    const { title, description, tags, id, venue } = this.props.lecture;
    const classname = classnames(styles.Lecture, this.props.className);
    const registerButton = this.renderRegisterButton();

    return (
      <div className={classname} id={id}>
        <h2 className={styles.Title}>{ title }</h2>
        <div dangerouslySetInnerHTML={{ __html: description }} />
        <div>Plätze: { this.seats }</div>
        <div>Datum: { this.date }</div>
        <div>Gebühr: { this.fee }€</div>
        <div>Veranstaltungsort: { venue }</div>
        <div>Kategorien: { tags.join(', ') }</div>
        {
          registerButton ?
            <div className={styles.Footer}>{ registerButton }</div> :
            null

        }
      </div>
    );
  }

  renderRegisterButton() {
    const { lecture } = this.props;
    const email = 'kontakt@tierverhalten.berlin';
    let subject = getRequestTitle(lecture);
    let body = getRequestMessage(lecture);
    let text = 'Terminanfrage';

    if (lecture.fee && lecture.date) {
      subject = getTitle(lecture);
      body = getMessage(lecture);
      text = 'Anmeldung';
    }

    return (
      <LinkButton to={`mailto:${email}?subject=${subject}&body=${body}`}>
      { text }
      </LinkButton>
    );
  }

  get date() {
    moment.locale('de');
    const { date, duration } = this.props.lecture;
    let text = 'Wird noch bekannt gegeben';

    if (date) {
      const _date = moment(date);
      text = _date.format('llll');

      if (duration) {
        text = `${text} - ${_date.add(duration, 'minutes').format('HH:mm')}`;
      }
    }

    return (<span>{text}</span>);
  }

  get seats() {
    const { seats } = this.props.lecture;
    return (<span>{seats || 'unbegrenzt'}</span>);
  }

  get fee() {
    const { fee } = this.props.lecture;
    let text = 'Wird noch bekannt gegeben';

    if (fee) {
      text = (fee / 100).toFixed(2);
    }

    return (<span>{text}</span>);
  }
}



// WEBPACK FOOTER //
// ./src/components/lecture/lecture.component.jsx